import React from 'react';
import { PageHero } from '../components/ui/PageHero';
import { ServiceCard } from '../components/ui/ServiceCard';
import { EmergencyCTA } from '../components/sections/EmergencyCTA';
import { ProcessSection } from '../components/sections/ProcessSection';
import { SERVICES } from '../lib/site';
export function Services() {
  return <>
      <PageHero eyebrow="Services" title="Restoration & Construction, Perfected" subtitle="A complete range of premium services — from emergency mitigation to full luxury remodels." crumbs={[{
      label: 'Home',
      to: '/'
    }, {
      label: 'Services'
    }]} data-id="element-558" data-mp="3ji9q1w0wjzwg" />
      <section className="mx-auto max-w-7xl px-6 pb-24" data-id="element-559" data-mp="65zpay2hsu7l">
        <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4" data-id="element-560" data-mp="2cveak0ai4nbf">
          {SERVICES.map((s, i) => <ServiceCard key={s.slug} service={s} index={i} data-id="element-561" data-mp="27wum9t8fqzfw" data-mpi={i} />)}
        </div>
      </section>
      <ProcessSection data-id="element-562" data-mp="16pcni5ddeb9t" />
      <EmergencyCTA data-id="element-563" data-mp="16q48ynd96smd" />
    </>;
}